import { render, staticRenderFns } from "./CreateNotificationModal.vue?vue&type=template&id=7d0af075&"
import script from "./CreateNotificationModal.vue?vue&type=script&lang=ts&"
export * from "./CreateNotificationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports